// About-this-calculator explanations, keyed by calculator slug.
// Used by CalculatorLayout to render an automatic info section below the result.

export const CALCULATOR_ABOUT = {
  'bmi': {
    title: 'About the BMI Calculator',
    description: 'Calculate your Body Mass Index to understand whether your weight falls within a healthy range. Quickly assess underweight, normal, overweight, or obesity categories.'
  },
  'water-intake': {
    title: 'About the Daily Water Intake Calculator',
    description: 'Estimate your ideal daily hydration needs based on body weight and activity level. Helps improve energy, recovery, metabolism, and overall health.'
  },
  'calorie-deficit': {
    title: 'About the Calorie Deficit Calculator',
    description: 'Find the ideal calorie target for healthy and sustainable fat loss. Get personalized deficit recommendations based on your body and activity.'
  },
  'protein-intake': {
    title: 'About the Protein Intake Calculator',
    description: 'Calculate your optimal daily protein intake for muscle gain, fat loss, or maintenance. Supports better recovery, strength, and body composition goals.'
  },
  'tdee': {
    title: 'About the TDEE Calculator',
    description: 'Estimate your Total Daily Energy Expenditure and daily calorie needs. Useful for planning fat loss, maintenance, or muscle-building nutrition.'
  },
  'macro': {
    title: 'About the Macro Calculator',
    description: 'Get personalized protein, carbs, and fat targets based on your fitness goals. Designed to simplify balanced nutrition and performance-focused eating.'
  },
  'body-fat': {
    title: 'About the Body Fat Percentage Calculator',
    description: 'Estimate your body fat percentage using scientific body measurements. Understand body composition beyond just weight and BMI.'
  },
  'lean-body-mass': {
    title: 'About the Lean Body Mass Calculator',
    description: 'Calculate your total body weight excluding body fat. Useful for muscle tracking, protein planning, and fitness analysis.'
  },
  'ideal-weight': {
    title: 'About the Ideal Weight Calculator',
    description: 'Estimate your healthy body weight range using medical formulas. Helpful for setting realistic and sustainable fitness goals.'
  },
  'ffmi': {
    title: 'About the FFMI Calculator',
    description: 'Measure your Fat-Free Mass Index to evaluate muscularity and physique development. Popular among athletes and advanced fitness enthusiasts.'
  },
  'waist-to-hip': {
    title: 'About the Waist-to-Hip Ratio Calculator',
    description: 'Analyze fat distribution and potential cardiovascular health risk. A strong indicator of abdominal obesity and metabolic health.'
  },
  'heart-rate-zones': {
    title: 'About the Heart Rate Zone Calculator',
    description: 'Discover your ideal training heart rate zones for fat burn and cardio fitness. Helps optimize workouts, endurance, and recovery.'
  },
  'vo2-max': {
    title: 'About the VO₂ Max Calculator',
    description: 'Estimate your aerobic fitness and cardiovascular endurance capacity. Widely used to measure athletic and heart health performance.'
  },
  'one-rep-max': {
    title: 'About the One Rep Max (1RM) Calculator',
    description: 'Estimate the maximum weight you can lift for one repetition safely. Useful for strength training, progressive overload, and workout planning.'
  },
  'pace': {
    title: 'About the Running Pace Calculator',
    description: 'Calculate your running pace, speed, and estimated finish times. Perfect for runners, walkers, and endurance training programs.'
  },
  'pregnancy-weight-gain': {
    title: 'About the Pregnancy Weight Gain Calculator',
    description: 'Track healthy pregnancy weight gain based on trimester and body metrics. Supports safer prenatal wellness and maternal health monitoring.'
  },
  'sleep': {
    title: 'About the Sleep Calculator',
    description: 'Find the best sleep and wake times based on natural sleep cycles. Improve recovery, energy levels, mental focus, and hormonal balance.'
  },
  'intermittent-fasting': {
    title: 'About the Intermittent Fasting Calculator',
    description: 'Plan your fasting and eating windows with popular fasting methods. Helps support fat loss, metabolic health, and disciplined eating habits.'
  },
  'calorie-burn': {
    title: 'About the Calorie Burn Calculator',
    description: 'Estimate calories burned during different physical activities and workouts. Useful for tracking exercise intensity and daily energy expenditure.'
  },
  'steps-to-calories': {
    title: 'About the Steps to Calories Calculator',
    description: 'Convert your daily steps into estimated calories burned and walking distance. Encourages better daily activity tracking and movement goals.'
  },
  'bmi-prime': {
    title: 'About the BMI Prime Calculator',
    description: 'An advanced BMI analysis tool that compares your BMI against healthy standards. Provides a clearer understanding of weight-related health risk.'
  },
  'bsa': {
    title: 'About the Body Surface Area (BSA) Calculator',
    description: 'Calculate your total body surface area using medical formulas. Commonly used in clinical assessments and advanced health evaluations.'
  }
};

export const CALCULATOR_DISCLAIMER = `These calculators provide general health and fitness estimates based on the information entered and standard scientific formulas. They are intended for educational and informational purposes only and should not be considered a substitute for professional medical advice, diagnosis, or treatment.

Results may vary based on individual health conditions, body composition, lifestyle, medications, and clinical factors. Always consult a qualified healthcare professional or doctor before making significant changes to your diet, exercise routine, medication, or health management plan.`;
